import useGetMyAccountPipelines from '@/api/queries/me/useGetMyAccountPipelines';
import { Alert } from '@mui/material';
import DropdownField from '@payaca/components/dropdownField/DropdownField';
import ValidatedFieldWrapper from '@payaca/components/validatedFieldWrapper/ValidatedFieldWrapper';
import {
  AutomationCondition,
  ProgressProjectToPipelineStageActionConfig,
} from '@payaca/types/automationTypes';
import { FieldValidationResult } from '@payaca/types/fieldValidationTypes';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { GenericUserHelpTip } from '../genericUserHelpTip/GenericUserHelpTip';

export const ProgressProjectToPipelineStageActionConfigFieldset: FC<{
  conditions: AutomationCondition[];
  config: ProgressProjectToPipelineStageActionConfig;
  onChange: (changeValue: { [key: string]: any }) => void;
  validationState?: Record<string, FieldValidationResult>;
  touchedState?: Record<string, boolean>;
  onTouch?: (fieldName: string) => void;
  showFieldValidationMessagesUnconditionally?: boolean;
}> = (props) => {
  const {
    conditions,
    config,
    onChange,
    validationState,
    touchedState,
    onTouch,
    showFieldValidationMessagesUnconditionally,
  } = props;

  const pipelineIdString = conditions.find(
    (condition) =>
      condition.field === 'deal.pipelineId' && condition.operator === 'equals'
  )?.value;

  const { data: pipelinesData } = useGetMyAccountPipelines();

  const pipeline =
    pipelineIdString && pipelinesData
      ? pipelinesData.find((x) => x.id === pipelineIdString)
      : null;

  if (!pipeline) {
    return (
      <div className="mb-4">
        <Alert severity="warning">
          {
            'A "Project pipeline equals" condition is required to use this action'
          }
        </Alert>
      </div>
    );
  }

  const stageOptions = pipeline.stages.map((stage) => ({
    label: stage.title,
    value: stage.publicId,
  }));

  return (
    <fieldset className="deal-progression-automation-action-config-fieldset automation-action-config-fieldset">
      <ValidatedFieldWrapper
        validationResult={validationState?.targetStageId}
        isTouched={
          !!touchedState?.targetStageId ||
          showFieldValidationMessagesUnconditionally
        }
      >
        <DropdownField
          label={'Which stage should your project be moved to'}
          name={`targetStageId`}
          value={config.targetStageId}
          options={stageOptions}
          onChange={onChange}
          onTouch={onTouch}
        />
      </ValidatedFieldWrapper>
      <GenericUserHelpTip icon={<UntitledIcon name="info-circle.3" />}>
        {`We will only be able to move your project into this stage if it passes the guards - bear this in mind when making your choice!`}
      </GenericUserHelpTip>
    </fieldset>
  );
};
